import { NOTIFICATIONS } from "~/constans/notifications";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";

export const useCopyText = () => {
  const [addNotificator] = useAddNotificationMutation();

  const copyText = (copyText: string) => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        addNotificator({
          variables: {
            type: NOTIFICATIONS.success,
            content: `Скопировано ${copyText} в буфер обмена!`,
          },
        });
      })
      .catch((err) => {
        addNotificator({
          variables: {
            type: NOTIFICATIONS.error,
            content: `Не удалось скопировать ${copyText} в буфер обмена.`,
          },
        });
      });
  };
  return { copyText };
};
